import { cache } from '@/container/apollo-client/cache';
import { useToggleChannelPinMutation } from '@/types/generated/graphql';
import { notification } from 'antd';

export function useTogglePinAssignChannels() {
  const [togglePinChannels, { loading }] = useToggleChannelPinMutation({
    onCompleted: (res) => {
      notification.success({ message: res?.toggleChannelPin?.message });
      cache.modify({
        fields: {
          assignChannelsV2: () => {},
        },
      });
    },
    onError: (res) => {
      notification.error({ message: res?.message });
    },
  });

  function togglePinChannelsHandler(channelId: number) {
    togglePinChannels({
      variables: {
        channelId,
      },
    });
  }

  return {
    togglePinChannelsHandler,
    loading,
  };
}
